$(function () {
    $(".nzp-header__search-trigger").each(function (index, element) {
        var dialog = $("#nzp-search-dialog")[0];
        // console.log(dialog);

        //open
        $(element).on("click", function () {
            dialog.showModal();
            $("body").addClass("no-scroll");
            $("#nzp-search-input").focus();
        });

        //click out
        dialog.addEventListener("click", function (event) {
            if (event.target === dialog) {
                dialog.close();
                $("body").removeClass("no-scroll");
            }
        });

        //close button
        dialog.addEventListener("close", function () {
            dialog.close();
            $("body").removeClass("no-scroll");
        });
    });
});
